// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1sfWx","inner":"Footer_inner__3PziN","nextIcon":"Footer_nextIcon__U9uUU","innerLeft":"Footer_innerLeft__HUDEe"};